import { GooglePlaceDetail } from '@/components/inputs/GoogleAutocomplete';
import { ManualGooglePlaceData } from '@/lib/validations/ManualGooglePlaceDetailSchema';

import { AddressComponent } from './addressFromAddressComponents';

const parseStreetAddress = (address1: string): { streetNumber: string; route: string } => {
  const trimmed = address1.trim();

  // Match: optional unit number, then route
  const match = trimmed.match(/^(\d+[A-Za-z\-]*)\s+(.*)$/);

  if (match) {
    const streetNumber = match[1];
    const route = match[2];
    return { streetNumber, route };
  }

  // Fallback: treat entire thing as route if it doesn't match
  return { streetNumber: '', route: trimmed };
};

export const getManualPlaceDetail = (manualFields: ManualGooglePlaceData): GooglePlaceDetail => {
  const { streetNumber, route } = parseStreetAddress(manualFields.address1);

  const addressComponents: AddressComponent[] = [
    ...(streetNumber
      ? [
          {
            longText: streetNumber,
            shortText: streetNumber,
            types: ['street_number']
          }
        ]
      : []),
    {
      longText: route,
      shortText: route,
      types: ['route']
    },
    {
      longText: manualFields.city,
      shortText: manualFields.city,
      types: ['locality']
    },
    {
      longText: manualFields.region,
      shortText: manualFields.region,
      types: ['administrative_area_level_1']
    },
    {
      longText: manualFields.postalCode,
      shortText: manualFields.postalCode,
      types: ['postal_code']
    },
    {
      longText: manualFields.country,
      shortText: manualFields.country,
      types: ['country']
    }
  ];

  return {
    address1: manualFields.address1,
    address2: manualFields.address1,
    city: manualFields.city,
    region: manualFields.region,
    postalCode: manualFields.postalCode,
    country: manualFields.country,
    formattedAddress: `${manualFields.address1}, ${manualFields.city}, ${manualFields.region} ${manualFields.postalCode}, ${manualFields.country}`,
    lat: 0,
    lng: 0,
    addressComponents
  };
};
